// The property page lists every utility's login once; the modals that save one are separate components. A save
// announces itself here so that list reloads instead of saying "No portal credentials saved" until a page reload.
const CHANGED = 'livable:utility-credentials-changed';
export const notifyCredentialsChanged = () => window.dispatchEvent(new Event(CHANGED));

/** Returns the unsubscribe, so it can be a useEffect's cleanup. */
export const onCredentialsChanged = handler => {
  window.addEventListener(CHANGED, handler);
  return () => window.removeEventListener(CHANGED, handler);
};